// подключаем главную функцию с которой начинается выполнение
import {main} from 'boot';

// конфигурационный файл, определяющий сетевой идентификатор игры
import gameConfig from 'cfg/game-config.js';

// сгенерированная информация о версии игры
import versionInfo from './version';

// функция построения компонентов игры
import construct from './construct';

// графическая метрика пользовательского интерфейса
import uiConfig from 'cfg/userinterface-config';

import screenConfig from 'cfg/screen-config';

import resources from 'res/resources';

import {GAME_TYPE}  from 'network/network_api';

import SETTINGS from 'settings';
SETTINGS.slot_max_rotation = 0.400;

console.log(versionInfo.name + " build: " + versionInfo.build + " buildDate: " + versionInfo.buildDate);

import dull_bonus from 'dull_bonus'
dull_bonus()

// политика совершения пользователем выбора в бонусах
var bonusUserSelectionsPolicy = [
    {
        gameType : GAME_TYPE.BONUS_1,
        from : 0,
        to : 4
        // по-умолчанию выбор пользователя не уникален (на разных шагах бонуса может повторяться)
    },
    {
        gameType : GAME_TYPE.BONUS_2,
        from : 0,
        to : 4,
        exclusive : true    // выбор пользователя уникален от шага к шагу бонуса
    }
];

// entry point
main(
    resources,
    construct,
    {
        gameNetworkId:gameConfig.gameNetworkId,
        gameName:versionInfo.name,
        bonusUserSelectionsPolicy
    },
    {},
    uiConfig,
    screenConfig
);





// WEBPACK FOOTER //
// ./src/main.es6